export default __webpack_public_path__ + "static/media/Nick-Petrangelo.f5fa7d8c.png";